import { render } from "./EnterRegisterVerificationCodePage.vue?vue&type=template&id=2503f922&scoped=true"
import script from "./EnterRegisterVerificationCodePage.vue?vue&type=script&lang=js"
export * from "./EnterRegisterVerificationCodePage.vue?vue&type=script&lang=js"

import "./EnterRegisterVerificationCodePage.vue?vue&type=style&index=0&id=2503f922&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2503f922"]])

export default __exports__